import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useMsal } from '@azure/msal-react';
import { useTeams } from '../context/TeamsContext';

const LoginPage: React.FC = () => {
  const { login, isAuthenticated, user } = useAuth();
  const history = useHistory();
  const location = useLocation<{ from: { pathname: string } }>();
  const { accounts } = useMsal();
  const { isInTeams } = useTeams();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  // Determine where to redirect after successful authentication
  const from = location.state?.from?.pathname || '/';

  // Single effect to handle authentication state changes
  useEffect(() => {
    // For Teams: check if authenticated with Teams user
    // For Web: check if authenticated with MSAL accounts
    const hasValidAuth = isInTeams ? (isAuthenticated && user) : (isAuthenticated && accounts.length > 0);

    if (hasValidAuth) {
      history.replace(from);
    }
  }, [isAuthenticated, user, accounts.length, isInTeams, from, history]);

  const handleLogin = async () => {
    try {
      setIsLoggingIn(true);
      await login();
    } catch (error) {
      console.error('Login failed:', error instanceof Error ? error.message : 'Unknown error');
    } finally {
      setIsLoggingIn(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo-container">
          <img src="/vnt-logo.png" alt="VNT Logo" className="login-logo" />
        </div>
        <h2>Welcome to Chat VNT 2.0</h2>
        <div className="login-divider"></div>
        <p>Please sign in with your Azure Entra ID account to continue.</p>
        <button
          onClick={handleLogin}
          className="login-button"
          disabled={isLoggingIn}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" width="18" height="18" className="ms-logo">
            <path fill="#f3f3f3" d="M0 0h23v23H0z" />
            <path fill="#f35325" d="M1 1h10v10H1z" />
            <path fill="#81bc06" d="M12 1h10v10H12z" />
            <path fill="#05a6f0" d="M1 12h10v10H1z" />
            <path fill="#ffba08" d="M12 12h10v10H12z" />
          </svg>
          {isLoggingIn ? 'Signing in...' : 'Sign in with Microsoft'}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;